<template>
	<div class='col-xs-9 col-sm-7 newsletter tag-partner'>
		<span>Iscriviti alla newsletter e resta aggiornato sulle novità di Quomi</span>
		<form
			role="form"
			method="POST"
			name="newsletter"
			action=""
			class="form"
			:class="{' flex-vcenter': $mq.isDesktop() }"
			@submit.prevent="executeRecaptcha"
		>
			
			<input
				type="email"
				class="form-control"
				v-model="email"
				required
				placeholder="Inserisci la tua mail"
				autocomplete="email"
			>

			<CTA
				:content="`Iscriviti`"
				:size="`small`"
				type="submit"
				:disabled="newsletterLoading"
				:class="{'cta': !$mq.isDesktop() }"
			/>
		</form>

		<recaptcha ref="recaptcha" @verify="submit" class="flex flex-center my-3"></recaptcha>

		<div class="small-text pt-3">
			Iscrivendoti alla newsletter accetti le <router-link :to="{name: 'privacy-policy'}" :title='$t("components.checkbox.general_conditions")' target='_blank'>condizioni relative alla privacy</router-link>.
		</div>

		<div v-if="newsletterFlash" class="flash text-bold" :style="newsletterState === 'success' ? 'color: var(--quomi-primary)' : 'color: var(--quomi-red)' ">{{ newsletterFlash }}</div>
	</div>
</template>

<script>

import { newsletter } from '../../mixins/newsletter.js'
import CTA from '../Elements/CTA'
import Recaptcha from '../Elements/Recaptcha'
export default {
	data () {
		return {
			email: null,
			enabled: false
		}
	},
	mixins: [newsletter],

	components: {
		CTA,
		Recaptcha
	},
  methods: {
    // send your recaptcha token to the server to verify it
    submit () {
			this.$_newsletter_newsletterSubscribe({ email: this.email })
    },
    // execute the recaptcha widget
    executeRecaptcha () {
      this.$refs.recaptcha.render()
    }
  }
}
</script>

<style scoped>
input.form-control {
	margin: 0;
	flex-grow: 1;
}

.newsletter {
	margin: 0 auto 40px auto;
	width: 80%;
	max-width: 600px;
}

.newsletter a {
	color: white;
	text-decoration: underline;
}

.small-text {
	font-size: 13px;
}

.flash {
	margin: 10px auto 0 auto;
}

.flash.error {
	color: tomato;
}

.flash.success {
	color: white;
}

.cta {
	display: block;
	margin: 10px auto !important;
}

@media(max-width: 728px) {
	input.form-control + button, input.form-control + button:hover, input.form-control + button:focus {
		margin: 10px auto 0 auto !important;
	}
}

</style>
